var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 1.59375H11.9062V0.34375C11.9062 0.257812 11.8359 0.1875 11.75 0.1875H10.6562C10.5703 0.1875 10.5 0.257812 10.5 0.34375V1.59375H5.5V0.34375C5.5 0.257812 5.42969 0.1875 5.34375 0.1875H4.25C4.16406 0.1875 4.09375 0.257812 4.09375 0.34375V1.59375H0.8125C0.466797 1.59375 0.1875 1.87305 0.1875 2.21875V15.1875C0.1875 15.5332 0.466797 15.8125 0.8125 15.8125H15.1875C15.5332 15.8125 15.8125 15.5332 15.8125 15.1875V2.21875C15.8125 1.87305 15.5332 1.59375 15.1875 1.59375ZM14.4062 14.4062H1.59375V6.98438H14.4062V14.4062ZM1.59375 5.65625V3H4.09375V3.9375C4.09375 4.02344 4.16406 4.09375 4.25 4.09375H5.34375C5.42969 4.09375 5.5 4.02344 5.5 3.9375V3H10.5V3.9375C10.5 4.02344 10.5703 4.09375 10.6562 4.09375H11.75C11.8359 4.09375 11.9062 4.02344 11.9062 3.9375V3H14.4062V5.65625H1.59375Z",
    fill: "#737981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dbcf902e25e46087d87f9885493bd136.svg";
export { ForwardRef as ReactComponent };